import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import logoSrc from 'assets/lightblue-logo-slim.png';

const useStyles = makeStyles((theme) => ({
    container: {
        position: "relative",
        userSelect: "none"
    },
    logo: {
        width: "167px",
        userDrag: "none"
    },
    slogan: {
        position: "absolute",
        left: 0,
        width: "200px",
        fontFamily: "Lato",
        fontSize: "12px",
        left: 0
    },
    linkToHome: {
        textDecoration: "none",
        "&:visited": {
            color: "initial"
        }
    }
}))

export default function Logo(props) {

    const classes = useStyles();

    if (props.linkToHome) {
        return (
            <Link to="/" className={classes.linkToHome} {...props}>
                <div className={classes.container}>
                    <img src={logoSrc} width={"200px"} className={classes.logo} />
                    <div className={classes.slogan}>Remote Work Company Tracker</div>
                </div>
            </Link>
        )        
    }

    return (
        <div className={classes.container}>
            <img src={logoSrc} width={"200px"} className={classes.logo} />
            <div className={classes.slogan}>Remote Work Company Tracker</div>
        </div>
    )
}